export const ACTION_NAMES = {
  SECTOR: "sector",
  DOWNLOAD: "download",
  MORE: "more",
  SETTINGS: "settings",
  HISTORY: "history",
  ADD_FAVORITE: "addFavorite",
  REMOVE_FAVORITE: "removeFavorite",
  ADD: "add",
  EDIT: "edit",
  IMPORT: "import",
  REFRESH: "refresh",
  FILTER: "filter",
  GROUP_BY: "groupBy",
  MARK_REVIEWED: "markReviewed",
  MANAGE_TAXONOMY: "manageTaxonomy",
  BENCHMARK_MAPPING: "benchmarkMapping",
  MAPPED_ORG_JOBS: "mappedOrgJobs",
  COPY: "copy",
  MARK_ACTIVE: "markActive",
  MARK_INACTIVE: "markInactive",
  EDIT_RATING: "editRating",
  TEST: "test",
  SOURCE: "source",
  ADD_TO_PLAYLIST: "addToPlaylist",
  DELETE_PLAYLIST: "deletePlaylist",
  HELP: "help",
  INFO: "info",
  TASKS_IN_PROGRESS: "tasksInProgress",
  COMMENTS: "comments",
  CONFIDENCE_SCORE: "confidenceScore",
  COPILOT: "copilot",
  MIN_MAX: "minMax",
  CLOSE: "close",
  BASIC_FILTERS: "basicFilters",
  ADVANCED_QUERY: "advancedQuery",
  NEW_QUERY: "newQuery",
  SAVED_QUERIES: "savedQueries",
  PUBLISH: "publish",
  CANCEL: "cancel",
  SAVE: "save",
  NEXT: "next",
  BACK: "back",
  UPLOAD: "upload",
  UPDATE: "update",
  CUSTOM: "custom",
  PREVIEW: "preview"
};

export const ACTION_TYPES = {
  ICON: "icon",
  SWITCH: "switch",
  BUTTON: "button",
  ADD_ON: "addOn",
  CUSTOM: "custom",
};

export const PAGE_TITLE_STATUS = {
  NONE: "",
  ACTIVE: "active",
  // Same as SKILL_STATUS constant from web learning area
  MANUALLY_VERIFIED: "ManuallyVerified",
  SYSTEM_VERIFIED: "SystemVerified",
  PENDING: "Pending",
};
